import { defaultSchema } from "rehype-sanitize";

/**
 * The declared markdown subset.
 *
 * An unbounded grammar means the model eventually emits an H1 or a six-column table and
 * wrecks a chat bubble, so the renderer implements exactly one known set: bold, italic,
 * lists, inline code, line breaks, a separator line — plus links, which only ever come
 * from us.
 *
 * Note what is NOT here: `remark-gfm`, removed deliberately. Besides tables (out of the
 * subset) it enables autolink literals, which turn any bare URL in the model's output into
 * a live link — the precise vector that routing every link through a validated element
 * exists to close.
 */
export const MARKDOWN_SCHEMA = {
  ...defaultSchema,
  tagNames: [
    "p",
    "br",
    "strong",
    "em",
    "b",
    "i",
    "code",
    "pre",
    "ul",
    "ol",
    "li",
    // The advisor splits a long answer with "---"; without this the parts run together.
    "hr",
    "a",
    "span",
  ],
  attributes: {
    a: ["href", "title"],
    span: ["className"],
  },
  protocols: {
    ...defaultSchema.protocols,
    // Without this the sanitizer strips our own entity links: href only permits a known
    // set of protocols, and this scheme is not one of them.
    href: [...(defaultSchema.protocols?.href ?? []), "ryde-entity"],
  },
};
